import {configure, defineRule, ErrorMessage, Field, Form} from 'vee-validate';
import {localize, setLocale} from '@vee-validate/i18n';
import de from '@vee-validate/i18n/dist/locale/de.json';
import val_de from './vee-validate/val_de.json'
import {defineNuxtPlugin} from 'nuxt/app'
import * as rules from '@vee-validate/rules'
import moment from 'moment'

const rulesForErrorMessage = [
    'validation_pending'
]

export default defineNuxtPlugin((nuxtApp) => {
    const {$i18n} = useNuxtApp()
    const $t = $i18n.t
    /**************
     * Custom rules
     **************/

    // defineRule('confirm_password', (value, [password]) => value === password);
    rulesForErrorMessage.forEach(rule => defineRule(rule, () => false))


    defineRule('isInvalid', () => {
        return false
    });

    defineRule('tooManyFemales', (value) => {
        return value <= 0
    });

    defineRule('tooManyMales', (value) => {
        return value <= 0
    });

    defineRule('tooManyParticipants', (value) => {
        return value <= 0
    });

    defineRule('participantsRequired', (value) => {
        return value > 0
    });

    defineRule('personsRequired', (value) => {
        return value > 0
    });

    defineRule('caregiversRequired', (value) => {
        return value > 0
    });

    defineRule('minAgeInvoice', (value, {minAge}) => moment(value).isSameOrBefore(moment().subtract(minAge, 'years')));

    defineRule('minAgeContactPerson', (value, {minAge}) => moment(value).isSameOrBefore(moment().subtract(minAge, 'years')));

    defineRule('minAgeEventParticipant', (value, {
        minAge, eventStartDate, monthsOfAgeTolerance
    }) => {
        if (minAge <= 0) return true

        let targetDate = eventStartDate ? moment(eventStartDate) : moment()

        return moment(value).isSameOrBefore(
            targetDate.subtract(minAge ? minAge : 0, 'years')
                .add(monthsOfAgeTolerance ? monthsOfAgeTolerance : 0, 'months')
        );
    });

    defineRule('maxAgeEventParticipant', (value, {maxAge, eventEndDate, monthsOfAgeTolerance}) => {
        if (!maxAge) {
            return true
        }

        let targetDate = eventEndDate ? moment(eventEndDate) : moment()

        return moment(value).isAfter(
            //Addiere ein Jahr dazu, da in unserem Sprachgebrauch 0-3 Jahre bedeutet,
            //dass alle mitdürfen, die noch keine 4 Jahre alt sind. (Also z.b. 3 Jahre und 364 Tage darf auch mit)
            targetDate.subtract(maxAge + 1, 'years')
                .subtract(monthsOfAgeTolerance ? monthsOfAgeTolerance : 0, 'months')
        );
    });

    defineRule('correctAge', (value) => {
        if (!value) return true
        return moment(value).isAfter(moment().subtract(125, 'years'))
            && moment(value).isSameOrBefore(moment());
    });

    defineRule('correctDateFormat', (value) => {
        if (!value) return true
        return value?.length >= 6 // YYYY-MM-DD is default, IE11 might allow text, so DDMMYY is minimum
    });

    defineRule('dateInValidRange', (value) => {
        if (!value) return true
        return moment(value).year() >= 1753 // SQL Server minimum date
    });

    defineRule('phone', (value) => {
        return !value?.length || /^[0-9+\-/() ]{3,}$/.test(value)
    });

    defineRule('phoneInvalid', () => {
        return false
    });

    defineRule('juleicaInvalid', () => {
        return false
    });

    defineRule('juleicaCardNumberDoesntMatchWithContact', () => {
        return false
    });

    defineRule('pending', () => {
        return false
    });

    defineRule('dateIsInvalid', () => false);

    defineRule('validDate', (value) => {
        if (!value) return true

        try {
            if (moment(value, 'L').isValid()) return true
        } catch (e) {
            return false
        }

        try {
            return moment(value).isValid()
        } catch (e) {
            return false
        }
    });

    defineRule('dateIsAfter', (value, [date]) => {
        if (!date || !value) return true
        const errorMessage = 'Das Datum muss nach dem ' + moment(date).format('DD.MM.YYYY') + ' liegen.'
        try {
            if (moment(value, 'L').isValid()) {
                return moment(value, 'L').isSameOrAfter(date) ? true : errorMessage;
            }
            return moment(value).isSameOrAfter(date) ? true : errorMessage;
        } catch (e) {
            return errorMessage;
        }
    })

    defineRule('dateIsBefore', (value, [date]) => {
        if (!date || !value) return true
        const errorMessage = 'Das Datum muss vor dem ' + moment(date).format('DD.MM.YYYY') + ' liegen.'
        try {
            if (moment(value, 'L').isValid()) {
                return moment(value, 'L').isSameOrBefore(date) ? true : errorMessage;
            }
            return moment(value).isSameOrBefore(date) ? true : errorMessage;
        } catch (e) {
            return errorMessage;
        }
    })

    defineRule('addressIsIncomplete', (value) => {
        return !!value
    });

    defineRule('ibanInvalid', () => {
        return false
    });

    defineRule('invoiceRecipient', (value) => {
        return !!value
    });

    defineRule('contactPerson', (value) => {
        return !!value
    });

    defineRule('regexWithMessage', (value, {regex, message}) => {
        if (!value || value.toString().match(regex)) return true
        return message
    });

    defineRule('includes', (value, {text, message}) => {
        if (value.toString().toLowerCase().includes(text.toLowerCase())) return true
        return message ? message : false

    });
    /**************
     * Configuration
     **************/

    Object.keys(rules).forEach(rule => {
        if (rule === 'all') return;
        defineRule(rule, rules[rule]);
    });

    setLocale('de');

    nuxtApp.vueApp.component("VField", Field)
    nuxtApp.vueApp.component("VForm", Form)
    nuxtApp.vueApp.component("ErrorMessage", ErrorMessage)

    configure({
        generateMessage: (ctx) => localize(
            'de',
            {
                messages: {
                    [ctx.rule.name]: $t(`validations.${ctx.rule.name}`, {...ctx, ...ctx.rule.params}),
                },
                names: {...de.names, ...val_de.names}
            }
        )({...ctx, name: ctx.name?.includes('.') ? ctx.name.split('.').pop() : ctx.name}),
        classes: {
            valid: 'is-valid',
            invalid: 'is-invalid',
            dirty: ['is-dirty', 'is-dirty'] // multiple classes per flag!
        }
    });

    return {
        provide: {
            nestingFormKey: Symbol('nestingFormKey')
        }
    }
})
